export enum Schedule {
  NONE,
  DAILY,
  WEEKLY,
  MONTHLY,
}
